import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { DRAWER_WIDTH } from '@uptime/shared/constants';

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    backgroundColor: 'white',
  },
  toolbar: {
    paddingRight: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  appBar: {
    color: `${theme.palette.grey.black} !important`,
    backgroundColor: `${theme.palette.grey.white} !important`,
    boxShadow: `none !important`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    marginLeft: `${DRAWER_WIDTH}px`,
    borderRadius: `0 !important`,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${DRAWER_WIDTH}px) !important`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none !important',
    },
  },
  userName: {
    fontSize: 14,
    marginRight: `${theme.spacing(2)} !important`,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflowX: 'hidden',
  },
  logoutBtn: {
    color: `${theme.palette.primary} !important`,
  },
}));

export default useStyles;
